// // import { useState, useEffect } from 'react';
// // import { Link } from 'react-router-dom';
// // import { useWishlist } from '../context/WishlistContext';
// // import { getProducts }  from '../lib/api';
// // import ProductCard from '../components/shop/ProductCard';

// // export default function WishlistPage() {
// //   const { ids } = useWishlist();
// //   const [products, setProducts] = useState([]);
// //   const [loading,  setLoading]  = useState(true);

// //   useEffect(() => {
// //     getProducts().then(setProducts).catch(()=>setProducts([])).finally(()=>setLoading(false));
// //   }, []);

// //   const wishlisted = products.filter(p => ids.includes(p.id));

// //   return (
// //     <div style={{ paddingTop:88, paddingBottom:80, paddingLeft:40, paddingRight:40, minHeight:'100vh' }}>
// //       <div style={{ maxWidth:1440, margin:'0 auto' }}>
// //         <div style={{ marginBottom:44 }}>
// //           <div style={{ fontSize:11, letterSpacing:'0.22em', textTransform:'uppercase', color:'var(--gold)', fontWeight:500, marginBottom:10 }}>Saved</div>
// //           <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(32px,5vw,52px)', fontWeight:300, color:'var(--dark)', letterSpacing:'-0.01em' }}>My Wishlist</h1>
// //         </div>

// //         {loading ? (
// //           <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(210px,1fr))', gap:'20px', rowGap:56 }}>
// //             {Array.from({length:4}).map((_,i) => (
// //               <div key={i} className="animate-pulse">
// //                 <div style={{ aspectRatio:'3/4', background:'var(--grey)' }} />
// //                 <div style={{ height:11, background:'var(--grey)', width:'55%', margin:'14px auto 8px' }} />
// //                 <div style={{ height:11, background:'var(--grey)', width:'38%', margin:'0 auto' }} />
// //               </div>
// //             ))}
// //           </div>
// //         ) : wishlisted.length === 0 ? (
// //           <div style={{ padding:'80px 0', textAlign:'center', display:'flex', flexDirection:'column', alignItems:'center', gap:24 }}>
// //             <svg width={52} height={52} fill="none" stroke="var(--grey)" strokeWidth={1} viewBox="0 0 24 24">
// //               <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
// //             </svg>
// //             <p style={{ fontSize:11, color:'var(--grey-mid)', letterSpacing:'0.2em', textTransform:'uppercase' }}>Your wishlist is empty</p>
// //             <Link to="/shop" style={{ padding:'12px 32px', border:'1px solid var(--dark)', color:'var(--dark)', fontSize:11, letterSpacing:'0.2em', textTransform:'uppercase', fontWeight:600, textDecoration:'none', transition:'all 0.2s' }}
// //               onMouseEnter={e=>{ e.target.style.background='var(--dark)'; e.target.style.color='#fff'; }}
// //               onMouseLeave={e=>{ e.target.style.background='transparent'; e.target.style.color='var(--dark)'; }}>
// //               Browse Collection
// //             </Link>
// //           </div>
// //         ) : (
// //           <>
// //             <p style={{ fontSize:12, color:'var(--grey-mid)', marginBottom:28, letterSpacing:'0.05em' }}>{wishlisted.length} saved piece{wishlisted.length!==1?'s':''}</p>
// //             <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(210px,1fr))', gap:'20px', rowGap:56 }}>
// //               {wishlisted.map(p => <ProductCard key={p.id} product={p} />)}
// //             </div>
// //           </>
// //         )}
// //       </div>
// //     </div>
// //   );
// // }

// import { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { useWishlist } from '../context/WishlistContext';
// import { getProducts }  from '../lib/api';
// import ProductCard from '../components/shop/ProductCard';

// export default function WishlistPage() {
//   const { ids } = useWishlist();
//   const [products, setProducts] = useState([]);
//   const [loading,  setLoading]  = useState(true);

//   useEffect(() => {
//     getProducts().then(setProducts).catch(()=>setProducts([])).finally(()=>setLoading(false));
//   }, []);

//   const wishlisted = products.filter(p => ids.includes(p.id));

//   return (
//     <div style={{ paddingTop:88, paddingBottom:80, paddingLeft:40, paddingRight:40, minHeight:'100vh' }}>

//       {/* ── Responsive grid styles ── */}
//       <style>{`
//         .product-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
//           gap: 48px 24px;
//         }
//         @media (max-width: 768px) {
//           .product-grid {
//             grid-template-columns: repeat(2, 1fr);
//             gap: 32px 12px;
//           }
//             .wishlist-page {
//             padding-left: 10px !important;
//             padding-right: 10px !important;
//           }
//         }
//       `}</style>

//       <div style={{ maxWidth:1440, margin:'0 auto' }}>
//         <div style={{ marginBottom:44 }}>
//           <div style={{ fontSize:11, letterSpacing:'0.22em', textTransform:'uppercase', color:'var(--gold)', fontWeight:500, marginBottom:10 }}>Saved</div>
//           <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(32px,5vw,52px)', fontWeight:300, color:'var(--dark)', letterSpacing:'-0.01em' }}>My Wishlist</h1>
//         </div>

//         {loading ? (
//           <div className="product-grid">
//             {Array.from({length:4}).map((_,i) => (
//               <div key={i} className="animate-pulse">
//                 <div style={{ aspectRatio:'3/4', background:'var(--grey)' }} />
//                 <div style={{ height:11, background:'var(--grey)', width:'55%', margin:'14px auto 8px' }} />
//                 <div style={{ height:11, background:'var(--grey)', width:'38%', margin:'0 auto' }} />
//               </div>
//             ))}
//           </div>
//         ) : wishlisted.length === 0 ? (
//           <div className="wishlist-page"  style={{ padding:'80px 0', textAlign:'center', display:'flex', flexDirection:'column', alignItems:'center', gap:24 }}>
//             <svg width={52} height={52} fill="none" stroke="var(--grey)" strokeWidth={1} viewBox="0 0 24 24">
//               <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
//             </svg>
//             <p style={{ fontSize:11, color:'var(--grey-mid)', letterSpacing:'0.2em', textTransform:'uppercase' }}>Your wishlist is empty</p>
//             <Link to="/shop" style={{ padding:'12px 32px', border:'1px solid var(--dark)', color:'var(--dark)', fontSize:11, letterSpacing:'0.2em', textTransform:'uppercase', fontWeight:600, textDecoration:'none', transition:'all 0.2s' }}
//               onMouseEnter={e=>{ e.target.style.background='var(--dark)'; e.target.style.color='#fff'; }}
//               onMouseLeave={e=>{ e.target.style.background='transparent'; e.target.style.color='var(--dark)'; }}>
//               Browse Collection
//             </Link>
//           </div>
//         ) : (
//           <>
//             <p style={{ fontSize:12, color:'var(--grey-mid)', marginBottom:28, letterSpacing:'0.05em' }}>{wishlisted.length} saved piece{wishlisted.length!==1?'s':''}</p>
//             <div className="product-grid">
//               {wishlisted.map(p => <ProductCard key={p.id} product={p} />)}
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';
import { getProducts }  from '../lib/api';
import ProductCard from '../components/shop/ProductCard';

export default function WishlistPage() {
  const { ids } = useWishlist();
  const [products, setProducts] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    getProducts().then(setProducts).catch(()=>setProducts([])).finally(()=>setLoading(false));
  }, []);

  const wishlisted = products.filter(p => ids.includes(p.id));

  return (
    <div className="wishlist-page" style={{ paddingTop:88, paddingBottom:80, minHeight:'100vh' }}>

      {/* ── Responsive styles ── */}
      <style>{`
        .wishlist-page {
          padding-left: 40px;
          padding-right: 40px;
        }
        .product-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
          gap: 48px 24px;
        }
        @media (max-width: 768px) {
          .wishlist-page {
            padding-left: 16px;
            padding-right: 16px;
          }
          .product-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 32px 12px;
          }
        }
      `}</style>

      <div style={{ maxWidth:1440, margin:'0 auto' }}>
        <div style={{ marginBottom:44 }}>
          <div style={{ fontSize:11, letterSpacing:'0.22em', textTransform:'uppercase', color:'var(--gold)', fontWeight:500, marginBottom:10 }}>Saved</div>
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(32px,5vw,52px)', fontWeight:300, color:'var(--dark)', letterSpacing:'-0.01em' }}>My Wishlist</h1>
        </div>

        {loading ? (
          <div className="product-grid">
            {Array.from({length:4}).map((_,i) => (
              <div key={i} className="animate-pulse">
                <div style={{ aspectRatio:'3/4', background:'var(--grey)' }} />
                <div style={{ height:11, background:'var(--grey)', width:'55%', margin:'14px auto 8px' }} />
                <div style={{ height:11, background:'var(--grey)', width:'38%', margin:'0 auto' }} />
              </div>
            ))}
          </div>
        ) : wishlisted.length === 0 ? (
          <div style={{ padding:'80px 0', textAlign:'center', display:'flex', flexDirection:'column', alignItems:'center', gap:24 }}>
            <svg width={52} height={52} fill="none" stroke="var(--grey)" strokeWidth={1} viewBox="0 0 24 24">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
            <p style={{ fontSize:11, color:'var(--grey-mid)', letterSpacing:'0.2em', textTransform:'uppercase' }}>Your wishlist is empty</p>
            <Link to="/shop" style={{ padding:'12px 32px', border:'1px solid var(--dark)', color:'var(--dark)', fontSize:11, letterSpacing:'0.2em', textTransform:'uppercase', fontWeight:600, textDecoration:'none', transition:'all 0.2s' }}
              onMouseEnter={e=>{ e.target.style.background='var(--dark)'; e.target.style.color='#fff'; }}
              onMouseLeave={e=>{ e.target.style.background='transparent'; e.target.style.color='var(--dark)'; }}>
              Browse Collection
            </Link>
          </div>
        ) : (
          <>
            <p style={{ fontSize:12, color:'var(--grey-mid)', marginBottom:28, letterSpacing:'0.05em' }}>{wishlisted.length} saved piece{wishlisted.length!==1?'s':''}</p>
            <div className="product-grid">
              {wishlisted.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
          </>
        )}
      </div>
    </div>
  );
}